import behaviors from './behaviors';
import icons from './icons';
import logos from './logos';

export default {
  behaviors,
  icons,
  logos,
};
